import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { submitResendEsimQR } from "ducks/actions";
import SmartRender from "containers/SmartRender";
import { makeSelectSessionToken } from "ducks/selectors";
import NotEligible from "components/NotEligible";
import get from "lodash/get";
import FormattedMessage from "components/FormattedMessage";
import Alert from "react-s-alert";

const ResendEsimQR = Component =>
  function Comp(props) {
    const { token, match } = props;
    const { status: esimStatus } = get(match, "params", {});

    if (!token) return <NotEligible />;
    if (esimStatus)
      return (
        <NotEligible
          description={<FormattedMessage id={`esim_status_${esimStatus}`} />}
        />
      );
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  token: makeSelectSessionToken()
});

const mapDispatchToProps = dispatch => {
  return {
    submitResendEsimQR: (navigate, payload) => {
      dispatch(
        submitResendEsimQR(payload, (_, error) => {
          if (!error) {
            try {
              navigate();
            } catch (err) {
              Alert.error("Could not send Esim QR code", err);
            }
          } else {
            Alert.error("Could not send Esim QR code", error);
          }
        })
      );
    }
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onSubmit: navigate => {
    const token = stateProps?.token;
    token && dispatchProps.submitResendEsimQR(navigate, { token });
  }
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(ResendEsimQR(SmartRender));
